import { createStore } from 'vuex';

export default createStore({
  state: {
    user: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    }
  }
});


// import { createStore } from 'vuex';

// export default createStore({
//   state: {
//     user: null
//   },
//   mutations: {
//     setUser(state, user) {
//       state.user = user;
//     }
//   },
//   getters: {
//     getUser: (state) => state.user,
//     isAuthenticated: (state) => !!state.user
//   }
// });